import { post as axiosPost, get as axiosGet } from "./Axios";
import { BASE_URL } from "../redux/actions/types";

export function fileUpload(data, folderName) {
    const formData = new FormData();
    if (data != "") {
        Object.keys(data).map((key) => {
            formData.append(key, data[key]);
        });
    }
    return (dispatch) =>
        new Promise((resolve, reject) => {
            axiosPost(BASE_URL + "/api/giftcard/file/upload/" + folderName, formData, { Accept: "multipart/form-data" })
                .then(function (res) {
                    return resolve(res);
                })
                .catch(function (err) {
                    // handle error
                    return reject(data);
                });
        });
}

export function getFileUrl(fileName, folderName) {
    return BASE_URL + "/api/giftcard/file/get/" + folderName + "/" + fileName;
}
